import { IconHeartRateMonitor } from '@tabler/icons-react';

const analytics = {
    id: 'analytics',
    title: 'ANALYTICS',
    icon: IconHeartRateMonitor,
    type: 'group',
    breadcrumbs: false,
    url: '/analytics',
    tags: ['analytics', 'reports', 'statistics', 'data', 'insights', 'performance', 'metrics']
};

export default analytics;
